export const STORE_KEY = 'wc-ppcp/store/checkout';